<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-list-item-title>
                {{ value }}
            </v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    import Currency from "@/models/currency.model";
    export default {
        name: "FieldTipsReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
        computed: {
            value() {
                const currency = new Currency({iso: this.reply.field_tips.currency})
                return currency.displayAmount(this.reply.field_tips.amount)
            }
        }
    }
</script>

<style scoped>

</style>